// The six-digit sign-in code as typed, pasted or filled in by the OS.
//
// Japanese input methods type full-width digits; they are turned into ASCII
// rather than dropped (dropping them made a field nothing could be typed into).
// Separators are dropped and the code is cut at six digits here, not with
// maxLength (which would cut "123 456" before the space is dropped).

export const CODE_LENGTH = 6;

const FULL_WIDTH_DIGIT = /[０-９]/g;

export function normalizeCode(raw: string): string {
  return raw
    .replace(FULL_WIDTH_DIGIT, (c) =>
      String.fromCharCode(c.charCodeAt(0) - 0xfee0),
    )
    .replace(/\D/g, "")
    .slice(0, CODE_LENGTH);
}

/** Only the shape: a typo (no @, no domain) is caught before sending. */
export const looksLikeEmail = (s: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
